<template>
  <span>请注意，选择【生成】即扣除报告下载次数 ,<br />
    <template v-if="!isOrg">

      若当前账户内没有剩余下载次数，可以购买单篇报告，<br />
      或者点击右上角【会员套餐】购买超值套餐 ,<br />
    </template>
    目前系统支持生成近【2年】内的分析报告
  </span>

</template>

<script>

export default {
  name: 'genDialog',
  data: function () {
    return {
      isOrg: false
    }
  },

  mounted () {
    let tempOrgId = localStorage.getItem('selectedOrgId')
    if (tempOrgId && tempOrgId > 0) {
      this.isOrg = true
    }
  }

}
</script>
<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/components/index/GenDialog.vue